import { Form } from "antd"
import { TextTag, Button, Input } from "../../atoms"
import { withFormik } from "formik"
import React from "react"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import { registerByEmail } from "../../redux/actionCreators/auth"
import "./RegisterNewUserByEmail.scss"
import { EmailSignupValidation } from "../../validationSchema/EmailSigninSignupValidation"
import {
  CREATE_ACCOUNT,
  SIGN_UP_TO,
  LOGIN_BUTTON,
  EMAIL_PLACEHOLDER,
  PASSWORD_PLACEHOLDER,
  ALREADY_REGISTERED,
} from "../../constants/messages"

const FormItem = Form.Item

class S extends React.PureComponent {
  render() {
    const {
      values,
      handleSubmit,
      handleChange,
      handleBlur,
      touched,
      errors,
      isValid,
      dirty,
      isLoading,
      setFieldTouched,
    } = this.props

    return (
      <div id="RegisterNewUserByEmail" className="wdth100">
        <div className="signin-text">
          <TextTag textType="spaceName">{SIGN_UP_TO}</TextTag>
          <div className="noacc-text">
            <TextTag textType="sectionTextPrimary">
              {ALREADY_REGISTERED}
            </TextTag>
            <Link to="/login-email">
              <TextTag textType="linkText"> {LOGIN_BUTTON}</TextTag>
            </Link>
          </div>
        </div>
        <form onSubmit={handleSubmit}>
          <FormItem
            validateStatus={touched.email && errors.email ? "error" : undefined}
          >
            <Input
              name="email"
              placeholder={EMAIL_PLACEHOLDER}
              value={values.email}
              onChange={handleChange}
              onBlur={handleBlur}
              autoComplete="off"
              disabled={true}
              error={touched.email && errors.email ? errors.email : ""}
            />
          </FormItem>
          <FormItem
            validateStatus={
              touched.password && errors.password ? "error" : undefined
            }
          >
            <Input
              name="password"
              type="password"
              placeholder={PASSWORD_PLACEHOLDER}
              value={values.password}
              onChange={handleChange}
              onBlur={handleBlur}
              onInput={() => setFieldTouched("password", true)}
              error={touched.password && errors.password ? errors.password : ""}
            />
          </FormItem>

          <FormItem>
            <Button
              btnSize="large"
              btnType="primary"
              htmlType="submit"
              className="login-form-button"
              disabled={!dirty || !isValid || isLoading}
            >
              {CREATE_ACCOUNT}
            </Button>
          </FormItem>
        </form>
      </div>
    )
  }
}

export const RegisterPartnerByEmail = withFormik({
  validationSchema: EmailSignupValidation,
  mapPropsToValues: (props) => ({
    email: props.email,
    password: "",
  }),
  handleSubmit: async (values, { props, setErrors, setSubmitting }) => {
    if (localStorage.getItem("token")) return props.goToDashboard()
    else props.registerByEmail(values, true)
  },
})(S)

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  isLoading: state.loadingState.isAuthenticating,
})

export default connect(mapStateToProps, { registerByEmail })(
  RegisterPartnerByEmail
)
